import { handleActions } from 'redux-actions';

import { resourceStoreTypes, resourceUndoUpserters, resourceUpserters } from '../core';
import * as actions from './businessActions';
import type { BusinessProps } from './businessTypes';

const QcsSyncBusinessesStoreFactory = resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<BusinessProps>();

const reducer = handleActions<
  resourceStoreTypes.QcsSyncResourceStore<BusinessProps>,
  | ReturnType<typeof actions.getBusiness>
  | ReturnType<typeof actions.getBusinessSuccess>
  | ReturnType<typeof actions.getBusinessFailure>
  | ReturnType<typeof actions.createBusiness>
  | ReturnType<typeof actions.createBusinessSuccess>
  | ReturnType<typeof actions.createBusinessFailure>
  | ReturnType<typeof actions.updateBusiness>
  | ReturnType<typeof actions.updateBusinessSuccess>
  | ReturnType<typeof actions.updateBusinessFailure>
  | ReturnType<typeof actions.deleteBusiness>
  | ReturnType<typeof actions.deleteBusinessSuccess>
  | ReturnType<typeof actions.batchUpdateBusinesses>
  | ReturnType<typeof actions.batchUpdateBusinessesSuccess>
  | ReturnType<typeof actions.updateBusinessBump>
>(
  {
    [actions.getBusiness.type]: (state) => state.set('isLoading', true),
    [actions.getBusinessSuccess.type]: (state, { payload: data }) => resourceUpserters.upsertResources(state, data),
    [actions.getBusinessFailure.type]: (state, { payload: error }) => resourceUpserters.completeWithError(state, error),
    [actions.createBusiness.type]: (state, { payload: data }) => resourceUpserters.upsertResource(state, data),
    [actions.createBusinessSuccess.type]: (state, { payload: data }) => resourceUpserters.upsertResource(state, data),
    [actions.createBusinessFailure.type]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),
    [actions.deleteBusiness.type]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.createBusiness),
    [actions.deleteBusinessSuccess.type]: (state, { payload: data }) => resourceUpserters.upsertResource(state, data),
    [actions.updateBusiness.type]: (state, { payload: data }) => resourceUpserters.upsertResource(state, data),
    [actions.updateBusinessSuccess.type]: (state, { payload: data }) => resourceUpserters.upsertResource(state, data),
    [actions.updateBusinessFailure.type]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),
    [actions.batchUpdateBusinesses.type]: (state, action) =>
      resourceUndoUpserters.upsertResourcesSetupUndo(state, action, actions.batchUpdateBusinesses, false),
    [actions.batchUpdateBusinessesSuccess.type]: (state, action) =>
      resourceUndoUpserters.upsertResourcesSetupUndo(state, action, actions.batchUpdateBusinessesSuccess, true),
    [actions.updateBusinessBump.type]: (state, { payload }) => resourceUpserters.upsertResources(state, payload),
  },
  QcsSyncBusinessesStoreFactory(),
);

export default reducer;
